<h5 class="billing-info-headline">
  {{ 'booking.form.headline.contactAndLanguage' | transloco }}
</h5>
<form class="booking-data-form" [formGroup]="bookingDataForm">
  <markant-input
    class="billing-info-input"
    data-cy="billing-email-input"
    formControlName="billingEmail"
    [outlined]="true"
    [label]="('booking.form.formFields.billingEmail.label' | transloco) + '*'"
    [placeholder]="'booking.form.formFields.billingEmail.label' | transloco"
    [error]="
      billingEmail.errors
        | formControlError
          : submitted || billingEmail.touched || billingEmail.dirty
    "
    [errorText]="
      billingEmail.errors
        | formControlKeyError
          : 'booking.form.formFields.billingEmail.validation'
          : true
        | transloco
    "
    [helper]="'booking.form.formFields.billingEmail.help' | transloco"
    (markantFocus)="
      sendTrackingData('booking.form.formFields.billingEmail.label')
    "
  ></markant-input>
  <markant-select
    class="billing-info-input"
    data-cy="billing-language-select"
    formControlName="billingLanguageIsoCode"
    [outlined]="true"
    [label]="
      ('booking.form.formFields.billingLanguageIsoCode.label' | transloco) + '*'
    "
    [placeholder]="
      'booking.form.formFields.billingLanguageIsoCode.label' | transloco
    "
    [error]="
      billingLanguageIsoCode.errors
        | formControlKeyError
          : 'booking.form.formFields.billingLanguageIsoCode.validation'
          : submitted ||
              billingLanguageIsoCode.touched ||
              billingLanguageIsoCode.dirty
        | transloco
    "
    [helper]="'booking.form.formFields.billingLanguageIsoCode.help' | transloco"
    [options]="languageSelectOptions"
  ></markant-select>
</form>
